import { Avatar, Button, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { B2CLoginError, LeftArrowWhite, NewBlueDelete } from 'Images';

interface IReturnToMainDialog {
  onClickDelete: () => void;
  onClickContinue: () => void;
}

export const ReturnToMainDialog = ({
  onClickDelete,
  onClickContinue,
}: IReturnToMainDialog) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Reimbursements
  ).returnToMainDialog;
  const isDesktop = useIsDesktop();

  return (
    <Stack
      gap='24px'
      p={isDesktop ? '56px 110.5px' : '48px 24px 32px'}
      alignItems='center'
    >
      <Avatar
        alt=''
        src={B2CLoginError}
        sx={{ width: '152px', height: '103.83px' }}
      />
      <Stack alignItems='center' mb='36px'>
        <Typography
          component='h1'
          variant='h6'
          fontWeight='600'
          fontSize='24px'
          lineHeight='31px'
          textAlign={isDesktop ? undefined : 'center'}
        >
          {dictionary.title[0]}
        </Typography>
        <Typography
          component='h1'
          variant='h6'
          fontWeight='600'
          fontSize='24px'
          lineHeight='31px'
          textAlign={isDesktop ? undefined : 'center'}
        >
          {dictionary.title[1]}
        </Typography>
      </Stack>
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        justifyContent='center'
        gap='24px'
        alignItems={isDesktop ? undefined : 'center'}
        mt={isDesktop ? undefined : '30px'}
      >
        <Button
          variant='outlined'
          sx={{
            bgcolor: 'white',
            width: isDesktop ? '234px' : '100%',
            alignItems: 'center',
            gap: '4px',
            p: isDesktop ? '12px 0px' : '8px 0px',
            height: isDesktop ? undefined : '36px',
          }}
          onClick={onClickDelete}
        >
          <Avatar
            alt=''
            src={NewBlueDelete}
            sx={{ width: '20px', height: '20px' }}
          />
          <Typography variant='body4'>{dictionary.delete}</Typography>
        </Button>
        <Button
          variant='contained'
          sx={{
            bgcolor: '#3A6EEC',
            width: isDesktop ? '234px' : '100%',
            alignItems: 'center',
            gap: '4px',
            p: isDesktop ? '12px 0px' : '8px 0px',
            height: isDesktop ? undefined : '36px',
          }}
          onClick={onClickContinue}
        >
          <Typography variant='body4'>{dictionary.continue}</Typography>
          <Avatar
            alt=''
            src={LeftArrowWhite}
            sx={{ width: '20px', height: '20px' }}
          />
        </Button>
      </Stack>
    </Stack>
  );
};
